import React, { useState, useRef } from "react";
import { useMediaQuery, useTheme, Card, CardContent, CircularProgress, IconButton, CardMedia, Button, Stack, Chip, SelectChangeEvent, MenuItem, Select, FormControl, InputLabel, Pagination, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { ImageList, ImageListItem } from '@mui/material';
import { useGetProductsQuery } from '../features/products/productsApi.ts';
import '../css/App.css';
import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import deals_3 from '../assets/deals_3.jpg';
import deals_4 from '../assets/deals_4.jpg';
import deals_5 from '../assets/deals_5.jpg';
import deals_6 from '../assets/deals_6.jpg';
import Header from "../components/header.tsx";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Footer from "../components/footer.tsx";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { useLocation } from "react-router-dom";
import StarRating from "../components/star_ratings.tsx";
import LocalMallIcon from '@mui/icons-material/LocalMall';
import vivobook from '../assets/vivobook.jpeg';
import hp from '../assets/hp_pavilion.jpeg';
import macbook from '../assets/apple_macbook.jpeg';
import dell from '../assets/dell.jpeg';
import lenovolegion from '../assets/lenovolegion.jpeg';
import hp14 from '../assets/hp_14.jpg';
import lenovoideapad from '../assets/lenovo_ideapad.jpg';
import hpchromebook from '../assets/hp_chromebook_laptop.jpg';
import azeyou from '../assets/azeyou.jpg';
import hpPavilion from '../assets/hp_pavilion.jpeg';
import hp14ultralight from '../assets/hp_14_ultra_light.jpg';
import intel14 from '../assets/14_itel.jpg';
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { produce } from "immer";
import { useSelector } from "react-redux";
import CategoryIcon from '@mui/icons-material/Category';
import DevicesIcon from '@mui/icons-material/Devices';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import WeekendIcon from '@mui/icons-material/Weekend';
import KitchenIcon from '@mui/icons-material/Kitchen';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';

/* const categories = [
  "All", "Electronics", "Fashion", "Home", "Beauty", "Sports",
  "Kitchen", "Toys & Games", "Health & Wellness", "Books", "Baby Products",
  "Office Supplies", "Jewelry & Watches", "Grocery", "Pet Supplies",
  "Footwear", "Furniture", "Stationery"
]; */

const Product = () => {

  const darkMode = useSelector((state: any) => state.theme.darkMode);
  const navigate = useNavigate();
  const location = useLocation();
  const searchTerm = location.state?.searchTerm || "";
  const { data: items, error, isLoading } = useGetProductsQuery();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const scrollRef1 = useRef<HTMLDivElement>(null);
  const [sortOption, setSortOption] = useState("default");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [filters, setFilters] = useState({
    price: [],
    brand: [],
    processor: [],
    ram: [],
    storage: [],
    rating: [],
  });

  /* pagination */
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  const dealsProduct = [
    {
      id: 106,
      discount: '-38%',
      price: 'AED499.99',
      oldPrice: 'AED799.99',
      title: 'Samsung 55-Inch Class Crystal UHD 4K Smart TV with Alexa Built-In, HDR, LED Display, HDMI Ports, 2024 Model (UN55CU7000FXZA)',
      size: '55"',
      endsIn: '12:45:00',
      image: deals_1,
      rating: 4,
      category: false
    },
    {
      id: 107,
      discount: '-20%',
      price: 'AED299.99',
      oldPrice: 'AED379.99',
      title: 'JBL Flip 6 Portable Bluetooth Speaker, Powerful Sound and Deep Bass, IP67 Waterproof, 12 Hours Playtime, Black (New Model)',
      size: 'Compact',
      endsIn: '06:30:15',
      image: deals_2,
      rating: 2,
      category: false
    },
    {
      id: 101,
      discount: '-30%',
      price: 'AED699.99',
      oldPrice: 'AED999.99',
      title: 'ASUS VivoBook 15.6" FHD Thin and Light Laptop with AMD Ryzen 7 5700U, 16GB RAM, 512GB SSD, Windows 11, Backlit Keyboard and Fingerprint Sensor',
      size: '15.6"',
      endsIn: '15:00:00',
      image: vivobook,
      rating: 4,
      category: true
    },
    {
      id: 102,
      discount: '-35%',
      price: 'AED849.99',
      oldPrice: 'AED1299.99',
      title: 'HP Pavilion x360 Convertible 14" Touchscreen Laptop with 11th Gen Intel Core i5, 8GB RAM, 512GB SSD, Windows 11 Home, Stylus Pen Support',
      size: '14"',
      endsIn: '09:30:00',
      image: hp,
      rating: 4.5,
      category: true
    },
    {
      id: 103,
      discount: '-28%',
      price: 'AED1199.99',
      oldPrice: 'AED1649.99',
      title: 'Apple MacBook Air 13.6" Laptop 2023 Model with M2 Chip, Retina Display, 8GB Unified Memory, 256GB SSD, Fanless Design, macOS Ventura',
      size: '13.6"',
      endsIn: '20:45:00',
      image: macbook,
      rating: 3,
      category: true
    },
    {
      id: 104,
      discount: '-40%',
      price: 'AED1349.99',
      oldPrice: 'AED2249.99',
      title: 'Dell XPS 15 Premium Laptop - 15.6" 4K OLED Touch Display, Intel Core i7 12th Gen, 16GB RAM, 1TB SSD, NVIDIA RTX Graphics, Win 11 Pro',
      size: '15.6"',
      endsIn: '17:10:00',
      image: dell,
      rating: 3.5,
      category: true
    },
    {
      id: 105,
      discount: '-22%',
      price: 'AED949.99',
      oldPrice: 'AED1219.99',
      title: 'Lenovo Legion 5 Gaming Laptop with AMD Ryzen 7 5800H, 16GB RAM, 512GB SSD, 15.6" FHD 165Hz Display, NVIDIA GeForce RTX 3060, RGB Keyboard',
      size: '15.6"',
      endsIn: '14:25:00',
      image: lenovolegion,
      rating: 4,
      category: true
    },
    {
      id: 112,
      discount: '-50%',
      price: 'AED999.99',
      oldPrice: 'AED1999.99',
      title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
      size: '15.6"',
      endsIn: '18:00:00',
      image: deals_5,
      rating: 4.5
    },
    {
      id: 106,
      discount: '-22%',
      price: 'AED948.99',
      oldPrice: 'AED1219.99',
      title: 'HP 14 Laptop, Intel Celeron N4020, 4 GB RAM, 64 GB Storage, 14-inch Micro-edge HD Display, Windows 11 Home, Thin & Portable, 4K Graphics, One Year of Microsoft 365 (14-dq0040nr, Snowflake White)',
      size: '14"',
      endsIn: '14:25:00',
      image: hp14,
      rating: 4.1,
      category: true
    },
    {
      id: 107,
      discount: '-23%',
      price: 'AED950.99',
      oldPrice: 'AED1219.99',
      title: '14" Itel Laptop Computer- Intel Celeron N3350 (Dual-Core) | 4GB RAM | 256GB SSD | Ultra Slim Design | HDMI & USB 3.2 | 2.4G/5G WiFi | Webcam | for Home, Office & School',
      size: '14"',
      endsIn: '14:25:00',
      image: intel14,
      rating: 5,
      category: true
    },
    {
      id: 108,
      discount: '-25%',
      price: 'AED955.99',
      oldPrice: 'AED1220.99',
      title: 'Lenovo IdeaPad 3i Chromebook, 15.6” FHD Display, Intel Celeron N4500, 8GB RAM, 64GB eMMC, 1920x1080 px, 720p Camera, Chrome OS, Abyss Blue',
      size: '14"',
      endsIn: '14:25:00',
      image: lenovoideapad,
      rating: 4.3,
      category: true
    },
    {
      id: 110,
      discount: '-50%',
      price: 'AED999.99',
      oldPrice: 'AED1999.99',
      title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
      size: '15.6"',
      endsIn: '18:00:00',
      image: deals_5,
      rating: 3.8
    },
    {
      id: 111,
      discount: '-50%',
      price: 'AED999.99',
      oldPrice: 'AED1999.99',
      title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
      size: '15.6"',
      endsIn: '18:00:00',
      image: deals_5,
      rating: 4
    },
    {
      id: 109,
      discount: '-25%',
      price: 'AED955.99',
      oldPrice: 'AED1220.99',
      title: 'HP 14" Ultral Light Laptop for Students and Business, Intel Quad-Core, 8GB RAM, 192GB Storage(64GB eMMC+128GB Ghost Manta SD Card), 1 Year Office 365, USB C, Win 11 S',
      size: '14"',
      endsIn: '14:25:00',
      image: hp14ultralight,
      rating: 4.3,
      category: true
    },
    {
      id: 110,
      discount: '-21%',
      price: 'AED955.99',
      oldPrice: 'AED1220.99',
      title: 'Azeyou FHD 15.6" Laptop Computer, Ryzen 3 3200U Processor Notebook Computer, 16GB DDR4 RAM 512GB PCle SSD Bussiness Laptop, OS 11 PRO Student Computer, Dual Band WiFi/BT5.0/Type-C/HDMI/4500mAH, Black',
      size: '14"',
      endsIn: '14:25:00',
      image: azeyou,
      rating: 3.9,
      category: true
    },
    {
      id: 111,
      discount: '-21%',
      price: 'AED955.99',
      oldPrice: 'AED1220.99',
      title: 'HP Chromebook 14 Laptop, Intel Celeron N4120, 4 GB RAM, 64 GB eMMC, 14" HD Display, Chrome OS, Thin Design, 4K Graphics, Long Battery Life, Ash Gray Keyboard (14a-na0226nr, 2022, Mineral Silver)',
      size: '14"',
      endsIn: '14:25:00',
      image: hpchromebook,
      rating: 4.3,
      category: true
    }/* ,
    {
      id: 106,
      discount: '-38%',
      price: 'AED499.99',
      oldPrice: 'AED799.99',
      title: 'Samsung 55-Inch Class Crystal UHD 4K Smart TV with Alexa Built-In, HDR, LED Display, HDMI Ports, 2024 Model (UN55CU7000FXZA)',
      size: '55"',
      endsIn: '12:45:00',
      image: deals_1,
      rating: 4
    },
    {
      id: 107,
      discount: '-20%',
      price: 'AED299.99',
      oldPrice: 'AED379.99',
      title: 'JBL Flip 6 Portable Bluetooth Speaker, Powerful Sound and Deep Bass, IP67 Waterproof, 12 Hours Playtime, Black (New Model)',
      size: 'Compact',
      endsIn: '06:30:15',
      image: deals_2,
      rating: 2
    },
    {
      id: 108,
      discount: '-45%',
      price: 'AED149.99',
      oldPrice: 'AED269.99',
      title: 'Sony WH-1000XM5 Wireless Industry Leading Noise Canceling Overhead Headphones with Microphone and Alexa Built-In, Black',
      size: 'Over-ear',
      endsIn: '03:12:50',
      image: deals_3,
      rating: 4.8
    },
    {
      id: 109,
      discount: '-25%',
      price: 'AED59.99',
      oldPrice: 'AED79.99',
      title: 'Apple Watch Series 9 [GPS + Cellular 42mm] Smartwatch with Midnight Aluminum Case, Midnight Sport Band, Fitness Tracker, Blood Oxygen Monitor',
      size: '42mm',
      endsIn: '10:00:00',
      image: deals_4,
      rating: 4
    },
    {
      id: 110,
      discount: '-50%',
      price: 'AED999.99',
      oldPrice: 'AED1999.99',
      title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
      size: '15.6"',
      endsIn: '18:00:00',
      image: deals_5,
      rating: 3.8
    },
    {
      id: 111,
      discount: '-50%',
      price: 'AED999.99',
      oldPrice: 'AED1999.99',
      title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
      size: '15.6"',
      endsIn: '18:00:00',
      image: deals_5,
      rating: 4
    },
    {
      id: 112,
      discount: '-50%',
      price: 'AED999.99',
      oldPrice: 'AED1999.99',
      title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
      size: '15.6"',
      endsIn: '18:00:00',
      image: deals_5,
      rating: 4.5
    },
    {
      id: 113,
      discount: '-25%',
      price: 'AED59.99',
      oldPrice: 'AED79.99',
      title: 'Apple Watch Series 9 [GPS + Cellular 42mm] Smartwatch with Midnight Aluminum Case, Midnight Sport Band, Fitness Tracker, Blood Oxygen Monitor',
      size: '42mm',
      endsIn: '10:00:00',
      image: deals_4,
      rating: 3.5
    },
    {
      id: 114,
      discount: '-25%',
      price: 'AED59.99',
      oldPrice: 'AED79.99',
      title: 'Apple Watch Series 9 [GPS + Cellular 42mm] Smartwatch with Midnight Aluminum Case, Midnight Sport Band, Fitness Tracker, Blood Oxygen Monitor',
      size: '42mm',
      endsIn: '10:00:00',
      image: deals_4,
      rating: 3
    },
    {
      id: 115,
      discount: '-45%',
      price: 'AED149.99',
      oldPrice: 'AED269.99',
      title: 'Sony WH-1000XM5 Wireless Industry Leading Noise Canceling Overhead Headphones with Microphone and Alexa Built-In, Black',
      size: 'Over-ear',
      endsIn: '03:12:50',
      image: deals_3,
      rating: 3
    },
    {
      id: 116,
      discount: '-45%',
      price: 'AED149.99',
      oldPrice: 'AED269.99',
      title: 'Sony WH-1000XM5 Wireless Industry Leading Noise Canceling Overhead Headphones with Microphone and Alexa Built-In, Black',
      size: 'Over-ear',
      endsIn: '03:12:50',
      image: deals_3,
      rating: 3.8
    }, */
  ];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dealsProduct.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };


  const scroll1 = (scrollOffset: any) => {
    if (scrollRef1.current) {
      scrollRef1.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
    }
  };


  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -150 : 150;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const handleSortChange = (event: SelectChangeEvent) => {
    setSortOption(event.target.value);
  };

  /* category */
  const categories = [
    { icon: <CategoryIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'All' },
    { icon: <DevicesIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Electronics' },
    { icon: <CheckroomIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Fashion' },
    { icon: <WeekendIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Furniture' },
    { icon: <KitchenIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Home' },
    { icon: <SportsSoccerIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Sports' },
    { icon: <DevicesIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Mobiles' },
    { icon: <CheckroomIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Clothing' },
    { icon: <WeekendIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Chairs' },
    { icon: <KitchenIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Kitchen' },
    { icon: <SportsSoccerIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Fitness' },
    { icon: <DevicesIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Gadgets' },
    { icon: <CheckroomIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Wearables' },
    { icon: <WeekendIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Sofas' },
    { icon: <KitchenIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Appliances' },
    { icon: <SportsSoccerIcon sx={{ color: '#C32032', fontSize: '32px' }} />, label: 'Games' }
  ];

  const catitemsPerPage = 10;
  const [pageIndex, setPageIndex] = useState(0);

  const maxPage = Math.ceil(categories.length / catitemsPerPage) - 1;

  const visibleItems = categories.slice(
    pageIndex * catitemsPerPage,
    (pageIndex + 1) * catitemsPerPage
  );
  /* end category */

  return (
    <Box sx={{ overflow: 'hidden' }}>
      {/* header section */}
      <Header />
      {/* End header section */}

      {/* category chips section */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2, mb: 1 }}>
        <IconButton onClick={() => scroll('left')}>
          <ArrowBackIosNewIcon />
        </IconButton>

        <Box
          ref={scrollRef}
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 1,
            p: 1,
            scrollBehavior: 'smooth',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            flexGrow: 1,
          }}
        >
          {categories.map((category, idx) => (
            <Chip
              key={idx}
              label={category}
              clickable
              variant="outlined"
              sx={{
                borderRadius: '16px',
                fontSize: '14px',
                color: '#C32032',
                borderColor: '#C32032',
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: '#fce4e4',
                },
              }}
            />
          ))}
        </Box>

        <IconButton onClick={() => scroll('right')}>
          <ArrowForwardIosIcon />
        </IconButton>
      </Box> */}
      {/* end category chips section */}
      {/* categories section */}
      <Box className="c-box">
        <Box className="c-box1">
          {/* Left Arrow */}
          <IconButton
            onClick={() => setPageIndex((prev) => Math.max(prev - 1, 0))}
            disabled={pageIndex === 0}
          >
            <ArrowBackIos />
          </IconButton>

          {/* Category Items */}
          <Box className="category-icons-box">
            {visibleItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  textAlign: 'center',
                  flex: `0 1 ${100 / itemsPerPage}%`,
                  maxWidth: `${100 / itemsPerPage}%`
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 60,
                    height: 60,
                    marginBottom: '6px',
                    color: '#C32032',
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="body2">{item.label}</Typography>
              </Box>
            ))}
          </Box>

          {/* Right Arrow */}
          <IconButton
            onClick={() => setPageIndex((prev) => Math.min(prev + 1, maxPage))}
            disabled={pageIndex === maxPage}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      </Box>
      {/* End categories section */}

      {/* Mobile Filter Chips */}
      <Box
        sx={{
          display: { xs: 'block', sm: 'none' }, // Mobile only
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          px: 1,
          py: 1,
          mb: 2,
          bgcolor: '#f5f5f5',
          borderRadius: 2,
          scrollbarWidth: 'none', // for Firefox
          '&::-webkit-scrollbar': { display: 'none' }, // for Chrome
        }}
      >
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          {['Under $25', '$25 to $50', '$50 to $100', 'Above $100', '4★ & above', '3★ & above'].map((label, idx) => (
            <Chip
              key={idx}
              label={label}
              clickable
              sx={{
                borderRadius: '16px',
                whiteSpace: 'nowrap',
                fontSize: '14px',
              }}
              variant="outlined"
            />
          ))}
        </Box>
      </Box>

      {/* product listing */}
      <Box sx={{ padding: '3%' }}>
        {searchTerm && (
          <Typography variant="h6" sx={{ mb: 2, color: darkMode ? '#fff' : '#333' }}>
            Search Results for "<strong>{searchTerm}</strong>"
          </Typography>
        )}

        <Box sx={{ p: 2 }}>
          {/* sort by */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="sort-label">Sort by</InputLabel>
              <Select
                labelId="sort-label"
                value={sortOption}
                label="Sort by"
                onChange={handleSortChange}
              >
                <MenuItem value="default">Default</MenuItem>
                <MenuItem value="priceLowHigh">Price: Low to High</MenuItem>
                <MenuItem value="priceHighLow">Price: High to Low</MenuItem>
                <MenuItem value="discountHighLow">Discount: High to Low</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {/* end sort by */}

          {/* <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)', xl: 'repeat(4, 1fr)' }, gap: 2 }}> */}
          <Box
            sx={{
              display: searchTerm ? 'flex' : 'grid',
              flexDirection: searchTerm ? 'column' : undefined,
              gridTemplateColumns: searchTerm
                ? undefined
                : { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)', xl: 'repeat(4, 1fr)' },
              gap: 2,
            }}
          >
            {/* {currentItems.map((product, index) => ( */}
            {/* <Card key={index} sx={{ borderRadius: 2, boxShadow: '0 2px 10px rgba(0,0,0,0.1)', transition: 'transform 0.2s ease-in-out', '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }, border: '1px solid #CBCBCB' }}> */}
            {searchTerm ? (
              <Box sx={{ display: 'flex', gap: 2 }}>
                {/* Left Side Filters (only once) */}
                <Box
                  sx={{
                    width: { xs: 0, sm: '30%', md: '25%', lg: '20%' },
                    display: { xs: 'none', sm: 'flex' },
                    flexDirection: 'column',
                    gap: 2,
                    borderRight: '1px solid #ccc',
                    pr: 2,
                  }}
                >
                  <Typography variant="h6">Filters</Typography>

                  {/* Brand */}
                  <Box>
                    <Typography variant="subtitle2">Brand</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox />} label="Dell" />
                      <FormControlLabel control={<Checkbox />} label="HP" />
                      <FormControlLabel control={<Checkbox />} label="Lenovo" />
                      <FormControlLabel control={<Checkbox />} label="Asus" />
                      <FormControlLabel control={<Checkbox />} label="Apple" />
                    </FormGroup>
                  </Box>

                  {/* Processor */}
                  <Box>
                    <Typography variant="subtitle2">Processor</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox />} label="Intel Core i3" />
                      <FormControlLabel control={<Checkbox />} label="Intel Core i5" />
                      <FormControlLabel control={<Checkbox />} label="Intel Core i7" />
                      <FormControlLabel control={<Checkbox />} label="AMD Ryzen 5" />
                      <FormControlLabel control={<Checkbox />} label="AMD Ryzen 7" />
                    </FormGroup>
                  </Box>

                  {/* RAM */}
                  <Box>
                    <Typography variant="subtitle2">RAM</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox />} label="4 GB" />
                      <FormControlLabel control={<Checkbox />} label="8 GB" />
                      <FormControlLabel control={<Checkbox />} label="16 GB" />
                      <FormControlLabel control={<Checkbox />} label="32 GB & above" />
                    </FormGroup>
                  </Box>

                  {/* Storage */}
                  <Box>
                    <Typography variant="subtitle2">Storage</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox />} label="256 GB SSD" />
                      <FormControlLabel control={<Checkbox />} label="512 GB SSD" />
                      <FormControlLabel control={<Checkbox />} label="1 TB SSD" />
                      <FormControlLabel control={<Checkbox />} label="1 TB HDD" />
                    </FormGroup>
                  </Box>

                  {/* Price */}
                  <Box>
                    <Typography variant="subtitle2">Price</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox />} label="Under ₹30,000" />
                      <FormControlLabel control={<Checkbox />} label="₹30,000 – ₹50,000" />
                      <FormControlLabel control={<Checkbox />} label="₹50,000 – ₹75,000" />
                      <FormControlLabel control={<Checkbox />} label="Above ₹75,000" />
                    </FormGroup>
                  </Box>

                  {/* Customer Ratings */}
                  <Box>
                    <Typography variant="subtitle2">Customer Ratings</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox />} label="4★ & above" />
                      <FormControlLabel control={<Checkbox />} label="3★ & above" />
                    </FormGroup>
                  </Box>
                </Box>

                {/* Right Side Products */}
                <Box
                  sx={{
                    width: { xs: '100%', sm: '70%', md: '75%', lg: '80%' },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                  }}
                >
                  {currentItems.filter((product) => product.category === true).map((product, index) => (
                    <Card
                      key={index}
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        borderRadius: 2,
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': {
                          transform: 'translateY(-5px)',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        },
                        border: '1px solid #CBCBCB',
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: {
                            xs: '100%',
                            sm: 200,
                          },
                          backgroundColor: '#f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Box
                          component="img"
                          src={product.image}
                          alt={`product-${index}`}
                          sx={{
                            maxWidth: '100%',
                            maxHeight: 120,
                            objectFit: 'contain',
                            p: 1,
                          }}
                        />
                      </Box>

                      {/* Content Right */}
                      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} onClick={() => navigate('/product-detail')}>
                        <Box>
                          <Typography sx={{ fontWeight: 500, fontSize: '18px', mb: 0.5 }}>
                            {product.title.length > 30
                              ? product.title.slice(0, 100) + '\n' + product.title.slice(30)
                              : product.title}
                          </Typography>
                          <Typography sx={{ fontSize: '13px', color: '#555' }}>
                            {product.size}
                          </Typography>
                          <StarRating rating={product.rating} />
                          <Box sx={{ mb: 1 }}>
                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                              {product.price}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                color: '#888',
                                textDecoration: 'line-through',
                              }}
                            >
                              {product.oldPrice}
                            </Typography>
                          </Box>
                          <Typography sx={{ fontSize: '13px', color: '#555' }}>
                            Ends in: {product.endsIn}
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                          <Button variant="contained" sx={{ flex: 1, fontSize: '13px', backgroundColor: '#C32032', maxWidth: isMobile ? '100%' : '15%', borderRadius: '50px', color: '#fff' }}>
                            Add to Cart
                          </Button>
                          <Button variant="outlined" sx={{ flex: 1, fontSize: '13px', border: '1px solid #C32032', color: darkMode ? '#fff' : '#C32032', fontWeight: 'bold', maxWidth: isMobile ? '100%' : '15%', borderRadius: '50px' }}>
                            Buy Now
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  ))}
                </Box>
              </Box>
            ) : (
              <>
                {currentItems.map((product, index) => (
                  <Card
                    key={index}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column', // Make it stack vertically
                      justifyContent: 'space-between',
                      height: '100%', // Important for consistent sizing
                      borderRadius: 2,
                      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                      transition: 'transform 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-5px)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                      },
                      border: '1px solid #CBCBCB'
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={product.image}
                      alt={`product-${index}`}
                      sx={{ height: 180, objectFit: 'cover' }}
                    />

                    {/* Main content */}
                    <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                      <Box sx={{ flexGrow: 1 }}>
                        <Box
                          sx={{
                            backgroundColor: '#ffe5e5',
                            color: '#d32f2f',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            display: 'inline-block',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1,
                            mb: 1,
                          }}
                        >
                          {product.discount}
                        </Box>

                        <Typography sx={{ fontWeight: 500, fontSize: '18px', mb: 0.5 }}>
                          {product.title.length > 95
                            ? `${product.title.slice(0, 95)}...`
                            : product.title}
                        </Typography>
                        <Typography sx={{ fontSize: '13px', color: '#555' }}>
                          {product.size}
                        </Typography>
                        <StarRating rating={product.rating} />
                        <Box sx={{ alignItems: 'center', gap: 1, mb: 1 }}>
                          <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                            {product.price}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '14px',
                              color: '#888',
                              textDecoration: 'line-through',
                            }}
                          >
                            {product.oldPrice}
                          </Typography>
                        </Box>



                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 2 }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="18"
                            viewBox="0 0 24 24"
                            width="18"
                            fill="#888"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                          </svg>
                          <Typography sx={{ fontSize: '13px', color: '#555' }}>
                            Ends in: {product.endsIn}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Action Buttons */}
                      <Box sx={{ display: 'flex', gap: 1, mt: 'auto' }}>
                        <Button
                          variant="contained"
                          sx={{ flex: 1, fontSize: '13px', textTransform: 'none', backgroundColor: '#C32032', borderRadius: '50px', color: '#fff' }}
                        >
                          Add to Cart
                        </Button>
                        <Button
                          variant="outlined"
                          sx={{ flex: 1, fontSize: '13px', textTransform: 'none', border: '1px solid #C32032', color: darkMode ? '#fff' : '#C32032', fontWeight: 'bold', borderRadius: '50px' }}
                        >
                          Buy Now
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </>)}
            {/* ))} */}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Pagination
              count={Math.ceil(dealsProduct.length / itemsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
            />

          </Box>
        </Box>
        {/* end product listing */}


        {/* Recommendations based on your order */}
        <Box sx={{ padding: '1%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography
              sx={{
                color: darkMode ? '#fff' : '#000',
                fontSize: '20px',
                fontWeight: 'bold',
                mb: 2,
                display: 'flex',
                gap: '5px',
                alignItems: 'center',
              }}
            >
              Recommendations based on your browsing history
            </Typography>
          </Box>

          {/* Carousel Wrapper */}
          <Box sx={{ position: 'relative' }}>
            {/* Left Arrow */}
            <IconButton
              sx={{
                position: 'absolute',
                top: '40%',
                left: -10,
                zIndex: 1,
                backgroundColor: darkMode ? 'black' : 'white',
                boxShadow: 2,
                '&:hover': { backgroundColor: darkMode ? '#000' : '#f0f0f0' },
                display: 'flex',
                width: 40,
                height: 40,
                borderRadius: '50%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => scroll1(-300)}
            >
              <ArrowBackIosIcon sx={{ ml: '8px' }} />
            </IconButton>

            {/* Products */}
            <Box
              ref={scrollRef1}
              sx={{
                display: 'flex',
                overflowX: 'auto',
                gap: 2,
                scrollBehavior: 'smooth',
                pb: 1,
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            >
              {dealsProduct.map((product, index) => (
                <Card
                  key={index}
                  sx={{
                    minWidth: 220,
                    flex: '0 0 auto',
                    borderRadius: 2,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    },
                    border: '1px solid #CBCBCB',
                    width: '275px'
                  }}
                >
                  <CardMedia component="img" image={product.image} alt={`product-${index}`} sx={{ height: 180, objectFit: 'cover' }} />
                  <CardContent sx={{ p: 2 }}>
                    <Box
                      sx={{
                        backgroundColor: '#ffe5e5',
                        color: '#d32f2f',
                        fontWeight: 'bold',
                        fontSize: '12px',
                        display: 'inline-block',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        mb: 1,
                      }}
                    >
                      {product.discount}
                    </Box>
                    <Box sx={{ alignItems: 'center', gap: 1 }}>
                      <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>{product.price}</Typography>
                      <Typography sx={{ fontSize: '14px', color: '#888', textDecoration: 'line-through' }}>{product.oldPrice}</Typography>
                    </Box>
                    <StarRating rating={product.rating} />
                    <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>{product.title.length > 95
                      ? `${product.title.slice(0, 95)}...`
                      : product.title}</Typography>
                    <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>{product.size}</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="#888">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                      </svg>
                      <Typography sx={{ fontSize: '13px', color: '#555' }}>Ends in: {product.endsIn}</Typography>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>

            {/* Right Arrow */}
            <IconButton
              sx={{
                position: 'absolute',
                top: '40%',
                right: -10,
                zIndex: 1,
                backgroundColor: darkMode ? 'black' : 'white',
                boxShadow: 2,
                '&:hover': { backgroundColor: darkMode ? '#000' : '#f0f0f0' },
                display: 'flex',
              }}
              onClick={() => scroll1(300)}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>
        {/* End Recommendations based on your order */}
      </Box>

      {/* footer */}
      <Footer />
      {/* end footer */}
    </Box >
  );
};

export default Product;